<template>
  <section class="fmhind-chart-frame">
    <header class="fmhind-chart-frame__header">
      <h3 class="fmhind-chart-frame__title">
        {{ title }}
      </h3>
    </header>
    <main class="fmhind-chart-frame__main">
      <slot />
    </main>
  </section>
</template>

<script>
export default {
  name: 'ChartFrame',
  props: {
    title: {
      type: String,
      required: false
    }
  }
};
</script>

<style lang="scss">
.fmhind-chart-frame {
  padding: $padding-md;
}

.fmhind-chart-frame__header {
  margin-bottom: $unit * 2;
}

.fmhind-chart-frame__title {
  @extend %text-lg;
  margin-bottom: $unit;
}

.fmhind-chart-frame,
.fmhind-chart-frame__header,
.fmhind-chart-frame__main {
  background: transparent;
}
</style>
